'use client';

import { useEffect, useState } from 'react';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayChildren, setDisplayChildren] = useState(children);

  useEffect(() => {
    setIsTransitioning(true);
    
    // Start exit animation
    const timer = setTimeout(() => {
      setDisplayChildren(children);
      
      // Start enter animation
      setTimeout(() => {
        setIsTransitioning(false);
      }, 50);
    }, 300);

    return () => clearTimeout(timer);
  }, [children]);

  return (
    <div
      className={`page-transition-wrapper ${
        isTransitioning ? 'page-transition-exit-active' : 'page-transition-enter-active'
      }`}
      style={{
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
        opacity: isTransitioning ? 0 : 1,
        transform: isTransitioning ? 'translateY(-20px)' : 'translateY(0)',
      }}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition;
